var map = {
	"./amazon.png": 9584,
	"./android.png": 568147,
	"./draugiem.png": 104022,
	"./hhru.png": 808399,
	"./instant.png": 965825,
	"./ios.png": 706197,
	"./macos.png": 965889,
	"./mbga.png": 412797,
	"./microsoft.png": 488402,
	"./mm.png": 793850,
	"./ok.png": 795098,
	"./rustore.png": 820532,
	"./vk.png": 628533,
	"./xsolla.png": 175743,
	"./yandex.png": 553039,
	"./youtube.png": 4349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 759747;